import { useState } from "react";
import { betSummary } from "../components/ui/RemoveBetSheet";

// useRemoveBetTarget (#1214 PR B, spec §16.3).
// Single job: hold the page's one Remove-sheet target, captured as { betId, summary } when a
// ticket or row asks, so the sheet outlives the card that opened it (P1-5). `settled` (#1221) picks the
// sheet copy and the expectSettled the sheet sends (#1731 B1).
// Reads: user, removeBet. Writes: nothing outside its own state.
// Does NOT: call the server or touch bets. onRequestRemove is undefined for guests (or when no
// removeBet is wired), which is what hides the ⋯ (§16.2).
// #1223: a target belongs to the user who captured it. When user.id changes (sign-out, account
// switch) the target is dropped during render, before the commit, so no render shows the
// previous account's bet; a token refresh (same id) keeps it.
export function useRemoveBetTarget({ user, removeBet }) {
  const uid = user?.id ?? null;
  const [target, setTarget] = useState(null);
  const [ownerUid, setOwnerUid] = useState(uid);
  if (ownerUid !== uid) {
    setOwnerUid(uid);
    setTarget(null);
  }
  const onRequestRemove = user && removeBet
    ? (bet) => setTarget({ betId: bet.id, summary: betSummary(bet), settled: !!bet.settledAt })
    : undefined;
  const closeRemove = () => setTarget(null);
  return { target: ownerUid === uid ? target : null, onRequestRemove, closeRemove };
}
